import { render, staticRenderFns } from "./UserComponent.vue?vue&type=template&id=60f3e680&scoped=true&"
import script from "./UserComponent.vue?vue&type=script&lang=js&"
export * from "./UserComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f3e680",
  null
  
)

export default component.exports